import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  $WxShare() {
    let wxcs = {
      src: 'http://admin.aqitai.com/fx_logo.jpg',
      titlestr: '内蒙古阿启泰科技有限公司',
      descstr: '内蒙古阿启泰科技有限公司是由一批具专业开发技术背景的it精英所组成，年轻、富有活力，效率优先。注定一开始就是一家成熟、有效率、技术强硬的科技公司，是一家专业从事蒙汉语网站pc建设、手机网站建设、网站推广和网络营销，电子商务平台建设、app开发（android和ios）、微信公众平台建设并二次开发、服务器接口开发、域名注册网站备案、服务器租用等业务的新型技术性互联网公司。'
    }
    let urlss = window.location.href
    let yy = ''
    if (window.location.href.indexOf('/#/') != -1) {
      urlss = window.location.href.substring(0, window.location.href.indexOf('/#/'))
      yy = window.location.href.substring(window.location.href.indexOf('/#/'))
    } else {
      if (window.location.href.indexOf('/?') != -1) {
        urlss = window.location.href.substring(0, window.location.href.indexOf('/?'))
        yy = window.location.href.substring(window.location.href.indexOf('/?'))
      }
    }
    let shareWxLink = window.location.origin + '/redirect.html?app3Redirect=' + encodeURIComponent(urlss + yy)
    if (window.Vm) {
      Vm.wx.ready(function () {
        // 分享给朋友
        Vm.wx.onMenuShareAppMessage({
          title: wxcs.titlestr,
          desc: wxcs.descstr,
          link: shareWxLink,
          imgUrl: wxcs.src,
          success: function () {
            alert('分享成功')
          },
        })
        // 分享到朋友圈
        Vm.wx.onMenuShareTimeline({
          title: wxcs.titlestr,
          link: shareWxLink,
          imgUrl: wxcs.src,
          success: function () {
            alert('分享成功')
          },
        })
      })
    }

  },
  routes: [
    //默认页
    {
      path: '/',
      redirect: '/Index',
    },
    //首页
    {
      path: '/Index',
      name: 'Index',
      component: re => {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Index.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Index.vue'], re)
        }
      }
    },
    //新闻页
    {
      path: '/News',
      name: 'News',
      component: re => {

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/News.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/News.vue'], re)
        }
      }
    },
    //案例页
    {
      path: '/Case',
      name: 'Case',
      component: re => {

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Case.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Case.vue'], re)
        }
      }
    },
    //服务页
    {
      path: '/Server',
      name: 'Server',
      component: re => {

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Server.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Server.vue'], re)
        }
      }
    },
    // 产品页
    {
      path: '/Product',
      name: 'Product',
      component: re => {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Product.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Product.vue'], re)
        }
      }
    },
    //个人中心
    {
      path: '/Personal',
      name: 'Personal',
      component: re => {

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Personal.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Personal.vue'], re)
        }
      }
    },
    //详情页
    {
      path: '/Details',
      name: 'Details',
      component: re => {

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // 手机
          require(['@/views/wap/Details.vue'], re)
        } else {
          // 电脑
          require(['@/views/pc/Details.vue'], re)
        }
      }
    },
  ]
})



